module.exports = __webpack_public_path__ + "static/media/function.651ff56e.svg";